<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<form [formGroup]="formGroup" (ngSubmit)="save()">
  <div class="modal-header">
    <div class="modal-title h5" id="modalTitle">User mapping settings</div>
    <button type="button" class="close" (click)="activeModal.close()" aria-label="Close modal?"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body">
    @if (errorMessage) {
    <alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
      <coso-alert-message>
        <div class="d-inline" [innerHTML]="errorMessage"></div>
      </coso-alert-message>
    </alert>
    }
    <p class="text-muted">
      <small><em>All fields are required unless specified optional</em></small>
    </p>
    <div class="form-group row">
      <label id="mappingModeLabel" class="col-form-label col-lg-4 col-md-12 text-lg-right">
        Mode
      </label>
      <div class="col-md-12 col-lg-6">
        <div class="btn-group-toggle" aria-labelledby="mappingModeLabel">
          <button
            type="button"
            name="mappingMode"
            class="btn btn-primary d-block d-sm-inline-block"
            [class.active]="formGroup.controls['mappingMode'].value === MappingMode.APPEND"
            (click)="formGroup.controls['mappingMode'].setValue(MappingMode.APPEND)"
            [disabled]="isReadOnly || groupStorage != GroupStorage.SharePoint"
            placement="top"
            data-toggle="tooltip"
            data-placement="top"
            data-original-title="Custom mapping will be appended to predefined mapping (Append)."
          >
            Automatic
          </button>
          <button
            type="button"
            name="mappingMode"
            class="btn btn-primary d-block d-sm-inline-block"
            [class.active]="formGroup.controls['mappingMode'].value === MappingMode.REPLACE"
            (click)="formGroup.controls['mappingMode'].setValue(MappingMode.REPLACE)"
            [disabled]="isReadOnly || groupStorage != GroupStorage.SharePoint"
            placement="top"
            data-toggle="tooltip"
            data-placement="top"
            data-original-title="Custom mapping will fully replace predefined mapping (Replace)."
          >
            Manual
          </button>
        </div>
      </div>
    </div>
    @if (formGroup.controls['mappingMode'].value == MappingMode.APPEND && groupStorage == GroupStorage.SharePoint) {
    <coso-toggle-input [control]="formGroup.controls['autoRefresh']" [inputText]="formText.autoRefresh" [readonly]="isReadOnly"></coso-toggle-input>
    @if (formGroup.controls['autoRefresh'].value === true) {
    <coso-text-input type="number" [control]="formGroup.controls['refreshInterval']" [inputText]="formText.refreshInterval" [readonly]="isReadOnly"></coso-text-input>
    } }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-{{ isReadOnly ? 'primary' : 'secondary' }}" (click)="activeModal.close()">{{ isReadOnly ? 'Close' : 'Cancel' }}</button>
    @if (!isReadOnly) {
    <button type="submit" class="btn btn-primary">Save</button>
    }
  </div>
</form>
